module.exports = __webpack_public_path__ + "static/img/Perancis.95eac7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/landmark/Perancis.png
// module id = Mlox
// module chunks = 1